export const previewDisclaimerButton = "SLa";
export default {previewDisclaimerButton};